

    const encodedProviderId = sessionStorage.getItem('provider_id');
const sidebarNav = [
    {
        link: '/',
        section: 'home',
        icon: <i className='bx bx-home-alt'></i>,
        text: 'Home'
    },
    {
        link: '/servicecategory',
        section: 'servicecategory',
        icon: <i className='bx bx-category'></i>, 
        text: 'Category'
    },
    {
        link: '/servicesform',
        section: 'servicesform',  // Matches /ServicesForm
        icon: <i className='bx bx-cube'></i>,
        text: 'Services'
      },
    {
        link: '/bookingreport',
        section: 'bookingreport',
        icon: <i className='bx bx-receipt'></i>,
        text: 'Bookings'
    },
    {
        link: '/customersreport',
        section: 'customersreport',
        icon: <i className='bx bx-user'></i>,
        text: 'Customers'
    },

    {
        link: '/servicereg',
        section: 'servicereg',
        icon: <i className='bx bx-user-plus'></i>, // Registration icon
        text: 'Provider Registration'
    },
    {
        link: '/providerprofile',
        section: 'providerprofile',
        icon: <i className='bx bx-user-circle'></i>, // Updated icon for the profile
        text: 'Profile'
    },
      
    {
        link: '/Analytics',
        section: 'Analytics',
        icon: <i className='bx bx-chart'></i>, // Unique icon
        text: 'Analytics'
    },
];

export default sidebarNav;


